import { createApp } from '@wu/widget-core';
import { meta } from './meta';
import { StoreLocator } from './store-locator';

const { appAlias: alias, appName: name } = meta;

export default createApp({ alias, name }, StoreLocator);
